import { connect } from "react-redux";

import CustomButton from "../../../common/CustomButton";
import CustomCard from "../../../common/CustomCard";

function FollowUpEmailCard(props) {
    const { metadata } = props;

    const success = metadata?.successList;
    const failed = metadata?.failedList;

    return (
        <>
            <div className="mb-5">
                <h5>
                    SUCCESSFULL
                </h5>
                {
                    success?.length > 0
                        ? success?.map((data) => {
                            return (
                                <div className="dcl-card dcl-followup-email-card">
                                    <CustomCard>
                                        <div className="row">
                                            <div className="col-4">
                                                <h6>PATIENT EMAIL:</h6>
                                                <h6>{data?.emailAddress?.toUpperCase()}</h6>
                                            </div>
                                            <div className="col-4">
                                                <h6>PATIENT INDI ID:</h6>
                                                <h6>{data?.patient_id}</h6>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-4">
                                                <h6>EMAIL TYPE:</h6>
                                                <h6>{data?.email_type?.toUpperCase()}</h6>
                                            </div>
                                            <div className="col-4">
                                                <h6>EMAIL ID:</h6>
                                                <h6>{data?.email}</h6>
                                            </div>
                                            <div className="col-4">
                                                <h6>EMAIL TRACKING ID:</h6>
                                                <h6>{data?.tracking_id}</h6>
                                            </div>

                                            {/* <div className="col-12 flex-r">
                                                <CustomButton size="small" className="mt-3">
                                                    Preview Email
                                                </CustomButton>
                                            </div> */}
                                        </div>

                                    </CustomCard>
                                </div>
                            )
                        })
                        : <h6><em>-- empty list --</em></h6>
                }
            </div>

            <div className="mb-5">
                <h5>
                    FAILED
                </h5>
                {
                    failed?.length > 0
                        ? failed?.map((data) => {
                            return (
                                <div className="dcl-card dcl-followup-email-card">
                                    <CustomCard>
                                        <div className="row">
                                            <div className="col-4">
                                                <h6>PATIENT EMAIL:</h6>
                                                <h6>{data?.emailAddress?.toUpperCase()}</h6>
                                            </div>
                                            <div className="col-4">
                                                <h6>PATIENT INDI ID:</h6>
                                                <h6>{data?.patient_id}</h6>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-4">
                                                <h6>EMAIL TYPE:</h6>
                                                <h6>{data?.email_type?.toUpperCase()}</h6>
                                            </div>
                                            <div className="col-4">
                                                <h6>EMAIL ID:</h6>
                                                <h6>{data?.email}</h6>
                                            </div>
                                            <div className="col-4">
                                                <h6>EMAIL TRACKING ID:</h6>
                                                <h6>{data?.tracking_id}</h6>
                                            </div>

                                            <div className="col-12 flex-r">
                                                <CustomButton size="small" className="mt-3">
                                                    Preview Email
                                                </CustomButton>
                                            </div>
                                        </div>

                                    </CustomCard>
                                </div>
                            )
                        })
                        : <h6><em>-- empty list --</em></h6>
                }
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    DailyCronLog: state.DailyCronLog
})

export default connect(mapStateToProps, {
})(FollowUpEmailCard);